__webpack_require__.p = "https://bundle.stayforlong.com/20260112.6/_next/";